import type { Pod } from '@/lib/graphql/types'

/**
 * Etichetta visiva di un POD da mostrare nelle UI (header, card, dialog).
 *
 * Regole:
 *  - `display`: l'etichetta personalizzata se presente (es. "Casa"),
 *    altrimenti l'indirizzo (es. "Via Roma 12"). Può essere `null` se
 *    nessuno dei due esiste.
 *  - `code`: il codice POD tecnico (es. `IT001E12345678`). Sempre mostrato
 *    quando presente.
 *
 * Es. output:
 *   { display: "Casa",          code: "IT001E12345678" }
 *   { display: "Via Roma 12",   code: "IT001E12345678" }
 *   { display: null,            code: "IT001E12345678" }
 */
export type PodLabelParts = {
  display: string | null
  code: string
}

export function getPodLabelParts(pod: Pod | null | undefined): PodLabelParts | null {
  if (!pod) return null
  const display = pod.etichetta?.trim() || pod.indirizzo?.trim() || null
  const code = pod.pod?.trim() ?? ''
  if (!display && !code) return null
  return { display, code }
}

/**
 * Versione "string flat" per i casi in cui serve un'unica stringa
 * (es. titoli pagina, screen reader). Compone display + codice con il
 * separatore "·", o restituisce solo quello disponibile.
 */
export function getPodLabel(pod: Pod | null | undefined): string {
  const parts = getPodLabelParts(pod)
  if (!parts) return ''
  if (parts.display && parts.code) return `${parts.display} · ${parts.code}`
  return parts.display ?? parts.code
}
